import React from "react";
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { CommonMenuItemProps } from "models/propTypes/menuPropTypes";
import Icon from "../icon";

const CommonMenuItem: React.FC<CommonMenuItemProps> = (props) => {
  return (
    <MenuItem
      onClick={props.onClick}
      disabled={props.disabled}
      className={clsx(
        cssExports.menuItem,
        props.selected ? cssExports.selectedMenuItem : "",
        props.icon ? cssExports.iconMenuItem : "",
        props.disabled ? cssExports.disabledMenuItem : "",
        props.className
      )}
    >
      {props.icon && (
        <ListItemIcon className={cssExports.menuIcon}>
          <Icon icon={props.icon} />
        </ListItemIcon>
      )}
      <ListItemText primary={props.text} className={cssExports.menuItemText} />
    </MenuItem>
  );
};

export default CommonMenuItem;
